module.exports = __webpack_public_path__ + "img/icon-account-pin@3x.71d8b0af.png";